import { render, staticRenderFns } from "./ChooseImage.vue?vue&type=template&id=37c45cc1&scoped=true"
import script from "./ChooseImage.vue?vue&type=script&lang=js"
export * from "./ChooseImage.vue?vue&type=script&lang=js"
import style0 from "./ChooseImage.vue?vue&type=style&index=0&id=37c45cc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c45cc1",
  null
  
)

export default component.exports